/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_body/activity_factor': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16.681 11s-2.145-4.127-2.447-4.127c-.26 0-2.399 4.127-2.399 4.127h4.846zm.418 1H2.864L1 15h18zm-5.761-1S7.661 4.121 7.355 4.121c-.288 0-4.03 6.879-4.03 6.879h8.013z"/>'
  }
})
